import type { GeneratedApp } from '@/types';
import { AppDocumentView } from '@/components/apps/AppDocumentView';
import { cardPreviewDocument, resolveAppDocument } from '@/components/apps/appDocument';

interface AppCardPreviewProps {
  app: GeneratedApp;
}

/**
 * Compact, formatted preview for app grid cards — never shows raw JSON.
 */
export function AppCardPreview({ app }: AppCardPreviewProps) {
  const document = resolveAppDocument(app);

  if (!document) {
    return (
      <p className="text-xs text-khiimori-text-muted line-clamp-3">
        Open to view generated output.
      </p>
    );
  }

  return (
    <div className="relative max-h-[11rem] overflow-hidden rounded-lg">
      <AppDocumentView document={cardPreviewDocument(document)} compact />
      <div
        className="pointer-events-none absolute inset-x-0 bottom-0 h-10 bg-gradient-to-t from-khiimori-bg-primary to-transparent"
        aria-hidden
      />
    </div>
  );
}
